import React from "react";
import { Routes, Route } from "react-router-dom";
import SuiteLayout from "../../_suite/SuiteLayout";
import TicketingDashboard from "../../ticketing";
import TicketQueuePage from "./TicketQueuePage";
import TicketingTicketDetailPage from "./TicketingTicketDetailPage";
import CustomerDirectoryPage from "./CustomerDirectoryPage";
import MacrosLibraryPage from "./MacrosLibraryPage";
import SlaSettingsPage from "./SlaSettingsPage";
import CustomerOrgDetailPage from "./CustomerOrgDetailPage";

export function TicketingSuiteSection() {
  return (
    <Routes>
      <Route element={<SuiteLayout vertical="ticketing" />}>
        <Route index element={<TicketingDashboard />} />
        <Route path="tickets" element={<TicketQueuePage />} />
        <Route path="tickets/:id" element={<TicketingTicketDetailPage />} />
        <Route path="customers" element={<CustomerDirectoryPage />} />
        <Route path="customers/:id" element={<CustomerOrgDetailPage />} />
        <Route path="macros" element={<MacrosLibraryPage />} />
        <Route path="sla" element={<SlaSettingsPage />} />
      </Route>
    </Routes>
  );
}
